import { useQuery } from '@tanstack/react-query';
import { getRelativeURLWithParams } from 'utils/url';
import { PLACES } from 'constants/endpoints.api';
import { REQUEST_ID_HEADER } from 'constants/headers';
import { getRequestId } from 'utils/requestId';
import { PlacesResponse } from './types';

interface PlacesQueryParams {
  searchValue: string;
}

export const usePlacesQuery = ({ searchValue }: PlacesQueryParams) =>
  useQuery<PlacesResponse>({
    queryKey: ['places', searchValue],
    queryFn: async () => {
      const url = getRelativeURLWithParams(PLACES, {
        searchValue
      });

      const res = await fetch(url, {
        headers: { [REQUEST_ID_HEADER]: getRequestId() }
      });

      return res.json();
    },
    // Query config
    enabled: !!searchValue
  });
